import { render, staticRenderFns } from "./DraggableButton.vue?vue&type=template&id=b507dcd4"
import script from "./DraggableButton.vue?vue&type=script&lang=js"
export * from "./DraggableButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports